/**
 * Route Wikimedia (and other CORB-blocked) image URLs through the backend
 * image proxy so browsers don't strip them for ORB/CORB reasons.
 * Data-URI SVGs and same-origin URLs are returned untouched.
 */
export function proxyImage(url) {
  if (!url) return '';
  if (url.startsWith('data:')) return url;
  const proxiedHosts = ['upload.wikimedia.org', 'commons.wikimedia.org', 'en.wikipedia.org', 'hi.wikipedia.org'];
  try {
    const u = new URL(url);
    if (proxiedHosts.includes(u.host)) {
      return `${process.env.REACT_APP_BACKEND_URL}/api/proxy-image?url=${encodeURIComponent(url)}`;
    }
  } catch (e) {
    // Invalid URL, return as-is
    console.debug('Invalid URL for proxy:', url);
  }
  return url;
}
